








































































import { Component, Prop, Emit, Watch } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { ModalFooter } from '@/components/molecules/ModalFooter'
import {
  ReserveReserveInfo,
  InputReserveItem,
  defaultInputReserveItem
} from '@/components/organisms/ReserveReserveInfo'
import { ReserveListTable } from '@/components/organisms/ReserveListTable'
import {
  Alert,
  AlertMessage,
  bibliographyRealApi,
  defaultSimpleBibliographyReal,
  defaultSystemCode,
  ErrorMessage,
  reserveApi,
  SimpleBibliographyReal,
  SystemCode
} from '@/api'
import { cloneDeep, merge } from 'lodash'
import { InputCode } from '@/components/molecules/InputCode'
import { InputCodeMultiple } from '@/components/molecules/InputCodeMultiple'
import {
  alertStore,
  modalErrorStore,
  systemCodeStore,
  systemParameterStore
} from '@/store'
import {
  NAV_LOADING_END,
  NAV_LOADING_START,
  PAGE_LOADING_END,
  PAGE_LOADING_START
} from '@/config/event'
import {
  defaultInputForwardingRequestItem,
  ForwardingRequestInfo,
  InputForwardingRequestItem
} from '@/components/organisms/ForwardingRequestInfo'
import CODE_KEY from '@/config/code_key'
import { BibliographyRealInfoSimple } from '@/components/organisms/BibliographyRealInfoSimple'
import { AlertCodeALC00012, SearchType } from '@/types'
import { BibliographyRealInfoMagazine } from '@/components/organisms/BibliographyRealInfoMagazine'

@Component({
  components: {
    BibliographyRealInfoMagazine,
    BibliographyRealInfoSimple,
    ReserveReserveInfo,
    ForwardingRequestInfo,
    ReserveListTable,
    ModalFooter,
    InputCode,
    InputCodeMultiple
  }
})
export default class ModalForwardingRequest extends ComponentVue {
  @Prop({
    type: Number,
    required: true
  })
  bibliographyRealId!: number

  @Prop({
    type: String,
    required: true
  })
  userId!: string

  @Prop({
    type: Object,
    required: true
  })
  reserveItem!: InputReserveItem

  dialog: boolean = false

  simpleBibliographyReal: SimpleBibliographyReal = defaultSimpleBibliographyReal()

  inputForwardingRequestItem: InputForwardingRequestItem = defaultInputForwardingRequestItem()

  inputReserveItem: InputReserveItem = defaultInputReserveItem()

  get forwardingRequestLevelItems(): SystemCode[] {
    return systemCodeStore.getForwardingRequestLevel
  }

  get defaultForwardingRequestBranchCodes(): string[] {
    return systemParameterStore.defaultForwardingRequestBranchCodes
  }

  get isMagazine(): boolean {
    return this.simpleBibliographyReal.searchType.code === SearchType.Magazine
  }

  @Watch('forwardingRequestLevelItems', { immediate: true, deep: true })
  onChangeForwardingRequestLevelItems() {
    if (this.forwardingRequestLevelItems.length > 0) {
      this.inputForwardingRequestItem.requestLevel.input = this.forwardingRequestLevelItems[0]
    }
  }

  @Watch('defaultForwardingRequestBranchCodes', { immediate: true, deep: true })
  onChangeDefaultForwardingRequestBranch() {
    this.inputForwardingRequestItem.requestBranch.input = this.defaultForwardingRequestBranchCodes.map(
      code => {
        return merge(defaultSystemCode(), { code })
      }
    )
  }

  open(): void {
    this.dialog = true
    this.inputReserveItem = cloneDeep(this.reserveItem)
    this.getSimpleBibliographyReal()

    systemCodeStore.fetchAllAndMergeByCodeKeys([
      CODE_KEY.FORWARDING_REQUEST_LEVEL.KEY,
      CODE_KEY.PROCESSING_PLACE.KEY
    ])

    systemParameterStore
      .fetchAllAndMergeByCodeKeys([
        CODE_KEY.DEFAULT_FORWARDING_REQUEST_BRANCH.KEY,
        CODE_KEY.MOBILE_LIBRARY_PROCESSING_PLACE.KEY,
        CODE_KEY.RESERVE_METHOD_PRESET_SETTING.KEY,
        CODE_KEY.RESERVE_SPECIFY_BRANCH_CODE_DEFAULT_SETTING.KEY
      ])
      .then(() => {
        this.inputReserveItem.reserveMethod.input =
          systemParameterStore.reserveMethodPresetValue
        this.inputReserveItem.reserveSpecifyBranch.input =
          systemParameterStore.defaultReserveSpecifyBranchCodes
      })
  }

  close(): void {
    this.dialog = false
    this.simpleBibliographyReal = defaultSimpleBibliographyReal()
    this.inputForwardingRequestItem = defaultInputForwardingRequestItem()
    this.inputReserveItem = defaultInputReserveItem()
  }

  onClickPrint(): void {
    const element = document.getElementById('modal-forwarding-request')
    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  onClickForwardingRequest() {
    this.forwardingRequest()
  }

  async getSimpleBibliographyReal(): Promise<void> {
    this.$eventBus.emit(NAV_LOADING_START)

    try {
      this.simpleBibliographyReal = await bibliographyRealApi.getSimpleBibliographyReal(
        this.bibliographyRealId
      )
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(NAV_LOADING_END)
    }
  }

  async forwardingRequest(_forceRequest: boolean = false) {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await reserveApi.forwardingRequest({
        userId: this.userId,
        bibliographyId: this.bibliographyRealId,
        forwardingRequestLevel: this.inputForwardingRequestItem.requestLevel
          .input,
        forwardingRequestMemo: this.inputForwardingRequestItem.requestMemo
          .input,
        forwardingRequestBranch: this.inputForwardingRequestItem.requestBranch
          .input,
        reserveMethod: this.inputReserveItem.reserveMethod.input,
        reserveSpecifyBranch:
          this.inputReserveItem.reserveMethod.input === '2'
            ? this.inputReserveItem.reserveSpecifyBranch.input
            : [],
        specifyCollectionId:
          this.inputReserveItem.reserveMethod.input === '3'
            ? this.inputReserveItem.specifyCollectionId.input
            : 0,
        specifyCollectionNo:
          this.inputReserveItem.reserveMethod.input === '3' &&
          this.inputReserveItem.specifyCollectionId.input === 0
            ? this.inputReserveItem.specifyCollectionNo.input
            : '',
        reserveRegistrationBranchCode: this.inputReserveItem.reserveBranch
          .input,
        reserveRegistrationPlaceCode: this.inputReserveItem.reservePlace.input,
        forwardingBranchCode: this.inputReserveItem.forwardingBranch.input,
        forwardingPlaceCode: this.inputReserveItem.forwardingPlaceCode.input,
        reserveRegistrationDate: this.inputReserveItem.reserveRegistrationDate
          .input,
        preferredDate: this.inputReserveItem.preferredDate.input,
        reserveNoticeAllowed: this.inputReserveItem.noticeAllowed.input,
        contactMethod: this.inputReserveItem.contactMethod.input,
        displayMemo: this.inputReserveItem.memo.input,
        _forceRequest,
        requestReserve: this.inputReserveItem.requestReserve.input
      })
      this.forwardRequestCompleted()
    } catch (error) {
      if (error instanceof AlertMessage) {
        this.setErrorMessage(error.alerts)
        if (
          error.alerts.length === 1 &&
          error.alerts[0].code === AlertCodeALC00012
        ) {
          alertStore.setItem(error.alerts[0])
          this.$modalAlert.open({
            onOkClick: () => {
              this.forwardingRequest(true)
            },
            onCancelClick: () => {}
          })
          return
        }
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          modalType: 'ERROR'
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  setErrorMessage(alerts: Alert[]) {
    alerts.forEach(alert => {
      switch (alert.attribute) {
        case 'forwarding_request_level':
          this.inputForwardingRequestItem.requestLevel.errorMessage =
            alert.message
          break
        case 'forwarding_request_memo':
          this.inputForwardingRequestItem.requestMemo.errorMessage =
            alert.message
          break
        case 'forwarding_request_branch_codes':
          this.inputForwardingRequestItem.requestBranch.errorMessage =
            alert.message
          break
        case 'reserve_specify_branch_codes':
          this.inputReserveItem.reserveSpecifyBranch.errorMessage =
            alert.message
          break
        case 'specify_collection_no':
          this.inputReserveItem.specifyCollectionNo.errorMessage = alert.message
          break
        case 'reserve_registration_branch_code':
          this.inputReserveItem.reserveBranch.errorMessage = alert.message
          break
        case 'reserve_registration_date':
          this.inputReserveItem.reserveRegistrationDate.errorMessage =
            alert.message
          break
        case 'reserve_registration_place_code':
          this.inputReserveItem.reservePlace.errorMessage = alert.message
          break
        case 'preferred_date':
          this.inputReserveItem.preferredDate.errorMessage = alert.message
          break
        case 'contact_method':
          this.inputReserveItem.contactMethod.errorMessage = alert.message
          break
        case 'forwarding_branch_code':
          this.inputReserveItem.forwardingBranch.errorMessage = alert.message
          break
        case 'forwarding_place_code':
          this.inputReserveItem.forwardingPlaceCode.errorMessage = alert.message
          break
        case 'display_memo':
          this.inputReserveItem.memo.errorMessage = alert.message
          break
      }
    })
  }

  @Emit('ok')
  forwardRequestCompleted() {
    this.close()
  }
}
